
/* styles */
require("!!../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../node_modules/vue-loader/lib/style-rewriter?id=data-v-bdf5a1f0!../node_modules/vue-loader/lib/selector?type=styles&index=0!./HomePage.vue")

var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./HomePage.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler?id=data-v-bdf5a1f0!../node_modules/vue-loader/lib/selector?type=template&index=0!./HomePage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/HomePage.vue
// module id = 285
// module chunks = 2